import logo from '@/images/logo.png';

export const WordmarkLogo: React.FC = () => (
  <img src={logo} alt='Masonic Exchange' className='logo logo--icon' />
);

export const IconLogo: React.FC = () => (
  <img src={logo} alt='Masonic Exchange' className='logo logo--icon' />
);

export const SymbolLogo: React.FC = () => (
  <img src={logo} alt='Masonic Exchange' className='logo logo--icon' />
);
